import { render, staticRenderFns } from "./FacturaBoleto.vue?vue&type=template&id=6c1e66fe&scoped=true&"
import script from "./FacturaBoleto.vue?vue&type=script&lang=js&"
export * from "./FacturaBoleto.vue?vue&type=script&lang=js&"
import style0 from "./FacturaBoleto.vue?vue&type=style&index=0&id=6c1e66fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1e66fe",
  null
  
)

export default component.exports